module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('transition', {
    attrs: {
      "name": "page-fade",
      "mode": "out-in"
    }
  }, [(_vm.playlist) ? _c('v-flex', {
    attrs: {
      "lg9": "",
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "pb-3"
  }, [_c('v-layout', {
    staticClass: "pa-3 hover-show-hidden",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "shrink": ""
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    staticClass: "hidden-xs-only",
    attrs: {
      "width": "224",
      "height": "126",
      "src": _vm.imgSrc
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hidden",
    staticStyle: {
      "position": "absolute",
      "bottom": "0",
      "left": "0",
      "right": "0"
    }
  }, [_c('v-btn', {
    staticClass: "no-transition",
    staticStyle: {
      "opacity": "0.9"
    },
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.play(false)
      }
    }
  }, [_vm._v("\n                                    PLAY ALL\n                                ")])], 1)])]), _vm._v(" "), _c('v-flex', {
    staticClass: "px-3"
  }, [_c('v-layout', {
    staticClass: "fill-height",
    attrs: {
      "column": ""
    }
  }, [_c('v-layout', {
    staticClass: "shrink",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', [_c('h1', {
    staticClass: "display-1 name truncate"
  }, [_vm._v(_vm._s(_vm.playlist.title))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "shrink": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": ""
    }
  }, [_c('v-btn', {
    staticClass: "hidden no-transition",
    attrs: {
      "slot": "activator",
      "flat": "",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "no-transition"
  }, [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', {
    key: _vm.playlist.id
  }, [_c('v-list-tile', {
    on: {
      "click": _vm.deletePlaylist
    }
  }, [_vm._v("\n                                                Delete Playlist\n                                            ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "slot": "activator",
      "icon": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.play('shuffled')
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("shuffle")])], 1), _vm._v(" "), _c('span', [_vm._v("Play shuffled")])], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "grey--text justify-end"
  }, [_c('span', [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "grey"
    }
  }, [_vm._v("person")])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.playlist.user.name))]), _vm._v(" "), _c('span', {
    staticClass: "created-at"
  }, [_vm._v(_vm._s(_vm.$timeago().format(_vm.playlist.created_at)))])])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    ref: "list-audios",
    staticClass: "py-0 use-hover",
    attrs: {
      "id": "list-audios",
      "two-line": ""
    }
  }, [_c('v-layout', {
    staticClass: "fill-height justify-center",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "fill-height",
    attrs: {
      "md9": ""
    }
  }, [_c('v-subheader', {
    staticClass: "fill-height"
  }, [_vm._v(_vm._s(_vm.playlist.audios.length) + " Audios")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "max-width": "250px"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.sortItems,
      "solo": "",
      "offset-y": ""
    },
    model: {
      value: (_vm.sort),
      callback: function($$v) {
        _vm.sort = $$v
      },
      expression: "sort"
    }
  })], 1)], 1), _vm._v(" "), _c('draggable', {
    attrs: {
      "options": _vm.draggableOptions
    },
    on: {
      "update": _vm.onUpdate,
      "start": _vm.onStart,
      "end": _vm.onEnd
    },
    model: {
      value: (_vm.playlist.audios),
      callback: function($$v) {
        _vm.$set(_vm.playlist, "audios", $$v)
      },
      expression: "playlist.audios"
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "list-basic"
    }
  }, _vm._l((_vm.playlist.audios), function(audio, index) {
    return _c('div', {
      key: audio.id
    }, [_c('playlist-audio', {
      attrs: {
        "audio": audio,
        "index": index,
        "playlist": _vm.playlist,
        "sort": _vm.sort
      },
      on: {
        "removed": _vm.onRemoved
      }
    }), _vm._v(" "), (index + 1 < _vm.playlist.audios.length) ? _c('v-divider') : _vm._e()], 1)
  }))], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c877356","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/PagePlaylist.vue
// module id = 370
// module chunks = 0